import { TextCol } from '@definitions/types/storyblokTypes'

import { createStoryblokRichtext } from '../../../../../__mocks__/storyblok/createStoryblokRichtext'

/**
 * Creates a mock TextCol
 * @param overrides - Partial fields to override defaults
 * @returns Complete TextCol mock
 */
export function createTextCol(overrides: Partial<TextCol> = {}): TextCol {
  return {
    _uid: '3caa5dca-2448-4917-ba2f-60164a72543b',
    content: createStoryblokRichtext('Lorem ipsum'),
    headline: 'Lorem ipsum',
    component: 'text-col',
    _editable:
      '<!--#storyblok#{"name": "text-col", "space": "235453", "uid": "3caa5dca-2448-4917-ba2f-60164a72543b", "id": "322787899"}-->',
    ...overrides,
  }
}
